/*export const toWaNumber = (raw) => {
  let d = String(raw || "").replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  if (d.startsWith("011")) d = d.slice(3);
  if (d.startsWith("521") && d.length === 13) d = "52" + d.slice(3);
  if (d.length === 10) d = "52" + d;
  return d;
};

export default function buildWaHref(raw) {
  let d = String(raw || "").replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  if (d.startsWith("011")) d = d.slice(3);
  if (d.startsWith("521") && d.length === 13) d = "52" + d.slice(3);
  if (d.length === 10) d = "52" + d;
  const text = encodeURIComponent("Hola, te escribo desde la app.");
  return `https://wa.me/${d}?text=${text}`;
}*/
export const splitPhones = (raw) => {
  // separa por / , ; o espacios múltiples
  return String(raw || "")
    .split(/[\/,;]| {2,}/g)
    .map((s) => s.trim())
    .filter(Boolean);
};

export const toWaNumber = (raw) => {
  let d = String(raw || "").replace(/\D/g, "");
  if (d.startsWith("00")) d = d.slice(2);
  if (d.startsWith("011")) d = d.slice(3);
  if (d.startsWith("521") && d.length === 13) d = "52" + d.slice(3);
  if (d.length === 10) d = "52" + d; // asume MX
  return d;
};

export const buildWaHref = (raw, text = "Hola, te escribo desde la app.") => {
  const phone = toWaNumber(raw);
  return `https://web.whatsapp.com/send?phone=${phone}&text=${encodeURIComponent(
    text
  )}`;
};
